orders-planner-orders
  .order-wrap(if="{orders[0]}" each="{order_id in this.orders}" id="planner_order_{order_id}")
    orders-planner-props(tag-scope="{dataScopeOrder(order_id)}" data-edit="{opts.dataEdit}" use-pin="{true}")
    orders-planner-lines(tag-scope="{dataScopeOrder(order_id)}" data-edit="{opts.dataEdit}")
  script(type="typescript").
    this.mixin('orders.planner.orders');
